export enum FileType {
    local = "local",
    deal = "deal"
}